import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

export const Icon = styled.div`
  margin-right: 3px;
  margin-left: 3px;
`;

export const Inside = styled.span`
  font-family: Gorga Grotesque Regular;
  vertical-align: middle;
  transform: translateY(-1px);

  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '12px')};
  color: #ffff;
`;
